import React from 'react'

function ComingSoon() {
  return (
    <div>
      
    </div>
  )
}

export default ComingSoon
